import clsx from "clsx"
import {Radio as RadioPrimitive} from "@base-ui/react/radio"
import {RadioGroup as RadioGroupPrimitive} from "@base-ui/react/radio-group"
import styles from "./Radio.module.css"


function RadioGroup({
						className,
						...props
					}: RadioGroupPrimitive.Props) {
	return (
		<RadioGroupPrimitive
			data-slot="radio-group"
			className={clsx(styles.group, className)}
			{...props}
		/>
	)
}

function RadioGroupItem({
							className,
							children,
							...props
						}: RadioPrimitive.Root.Props & {children?: React.ReactNode}) {
	return (
		<RadioPrimitive.Root
			data-slot="radio-group-item"
			className={clsx(styles.root, className)}
			{...props}
		>
			<RadioPrimitive.Indicator
				data-slot="radio-group-indicator"
				className={clsx(styles.indicator, className)}
				keepMounted
			/>
		</RadioPrimitive.Root>
	)
}

export {RadioGroup, RadioGroupItem}
